/**
 * Edit-via-AI navigation helper (CLE-41, final phase of CLE-37).
 *
 * The database is read-only from the user's perspective: every change is made by
 * the AI assistant, which writes the Knowledge Base markdown and re-derives the
 * DB via the sync engine. Instead of direct edit forms, the UI shows "Edit with
 * AI" actions that drop a pre-filled prompt into the chat and route the user to
 * the assistant.
 *
 * The pending prompt is handed off via sessionStorage so a full route change to
 * the chat page picks it up on mount (see ChatPage).
 */
export const CHAT_PENDING_PROMPT_KEY = 'ccc-chat-pending-prompt';

/** Stash a prompt for the chat composer and navigate to the assistant. */
export function openInChat(prompt: string): void {
  try {
    sessionStorage.setItem(CHAT_PENDING_PROMPT_KEY, prompt);
  } catch {
    // sessionStorage may be unavailable (private mode); fall back to a query param.
  }
  // Hard navigation keeps this helper dependency-free (usable outside Router
  // context); the chat page reads the pending prompt on mount either way.
  window.location.assign('/chat');
}

/** Read and clear any pending prompt. Returns '' when none is set. */
export function takePendingPrompt(): string {
  try {
    const value = sessionStorage.getItem(CHAT_PENDING_PROMPT_KEY) ?? '';
    if (value) sessionStorage.removeItem(CHAT_PENDING_PROMPT_KEY);
    return value;
  } catch {
    return '';
  }
}
